import { getAuthentication } from "../../lib/auth";
import { CATEGORIES_URL } from "../../lib/env";
import { gqlRequest } from "../../lib/functions";
import { categoryGQLSchema } from "../../lib/gql/Category";
import { ICategory } from "../../types/Category";

export async function getCategories(): Promise<ICategory[]> {
  const gqlString = `query{
        GetCategories{
            ${categoryGQLSchema}
        }
    }`;

  try {
    const response = await gqlRequest<{ GetCategories: ICategory[] }>({
      query: gqlString,
      endpoint: CATEGORIES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return [];
    }
    return response.data?.GetCategories || [];
  } catch (err) {
    throw err;
  }
}

export async function getCategoryByID(id: string): Promise<ICategory | null> {
  const gqlString = `query{
        GetCategoryByID(id:"${id}"){
            ${categoryGQLSchema}
        }
    }`;
  try {
    const response = await gqlRequest<{ GetCategoryByID: ICategory }>({
      query: gqlString,
      endpoint: CATEGORIES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return null;
    }
    return response.data?.GetCategoryByID || null;
  } catch (err) {
    throw err;
  }
}

export async function addNewCategory(title: string): Promise<ICategory | null> {
  const gqlString = `mutation{
    AddNewCategory(title:"${title}"){
      ${categoryGQLSchema}
    }
  }`;
  try {
    const response = await gqlRequest<{ AddNewCategory: ICategory }>({
      query: gqlString,
      endpoint: CATEGORIES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return null;
    }
    return response.data?.AddNewCategory || null;
  } catch (err) {
    throw err;
  }
}

export async function editCategoryTitle(
  id: string,
  title: string
): Promise<ICategory | null> {
  const gqlString = `mutation{
    EditCategoryTitle(id:"${id}",title:"${title}"){
      ${categoryGQLSchema}
    }
  }`;
  try {
    const response = await gqlRequest<{ EditCategoryTitle: ICategory }>({
      query: gqlString,
      endpoint: CATEGORIES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return null;
    }
    return response.data?.EditCategoryTitle || null;
  } catch (err) {
    throw err;
  }
}

export async function editCategorySeo(
  id: string,
  keywords: string[],
  description: string
): Promise<ICategory | null> {
  const gqlString = `mutation{
    EditCategorySeo(id:"${id}",
      description:"${description}",
      keywords:"${keywords.join(";")}"
    ){
      ${categoryGQLSchema}
    }
  }`;
  try {
    const response = await gqlRequest<{ EditCategorySeo: ICategory }>({
      query: gqlString,
      endpoint: CATEGORIES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return null;
    }
    return response.data?.EditCategorySeo || null;
  } catch (err) {
    throw err;
  }
}
